import { render } from "./ResultCard.vue?vue&type=template&id=fee594ea&scoped=true"
import script from "./ResultCard.vue?vue&type=script&lang=js"
export * from "./ResultCard.vue?vue&type=script&lang=js"

import "./ResultCard.vue?vue&type=style&index=0&id=fee594ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee594ea"]])

export default __exports__